export default __webpack_public_path__ + "static/media/defaultUserAvatar.8d41219c.png";